/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An organization-owned user-session issuer that uses this client for identity-provider login.
 */
export type TrustedClientUserSessionIssuerReference = {
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * The user_session_issuer slug.
   */
  slug: string;
};

/** @internal */
export const TrustedClientUserSessionIssuerReference$inboundSchema:
  z.ZodMiniType<TrustedClientUserSessionIssuerReference, unknown> = z.object({
    id: z.string(),
    slug: z.string(),
  });

export function trustedClientUserSessionIssuerReferenceFromJSON(
  jsonString: string,
): SafeParseResult<
  TrustedClientUserSessionIssuerReference,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      TrustedClientUserSessionIssuerReference$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'TrustedClientUserSessionIssuerReference' from JSON`,
  );
}
